import { render, staticRenderFns } from "./MovableTextObjectMenu.vue?vue&type=template&id=71152473&"
import script from "./MovableTextObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./MovableTextObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MovableTextObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports